import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { getApiUrl } from '../utils/api';
import { oublierEtablissement } from './auth/Connexion360';

const API = getApiUrl();

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { tenantSlug } = useParams();
  const basePath = tenantSlug ? `/${tenantSlug}` : '';
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];

      if (!sessionId) {
        navigate(basePath ? `${basePath}/login` : '/connexion');
        return;
      }

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId, tenant_slug: tenantSlug },
          { withCredentials: true }
        );

        oublierEtablissement(); setUser(response.data.user);
        // LOT 45 · seulement l'établissement rattaché à l'adresse, jamais un établissement par défaut
        window.location.assign(`/${String(response.data.user?.tenant_slug || response.data.user?.tenant_id || '').replace(/^tenant_/, '')}/dashboard`);
      } catch (error) {
        console.error('Auth error:', error);
        // On explique pourquoi (compte non invité, session expirée…) au lieu de renvoyer en silence sur la connexion
        const detail = typeof error.response?.data?.detail === 'string' ? error.response.data.detail : 'La connexion Google n’a pas abouti. Réessayez, ou utilisez votre e-mail et votre mot de passe.';
        navigate(basePath ? `${basePath}/login?mode=admin&erreur=${encodeURIComponent(detail)}` : `/connexion?erreur=${encodeURIComponent(detail)}`, { replace: true });
      }
    };

    processAuth();
  }, [navigate, setUser, basePath, tenantSlug]);

  return (
    <div className="min-h-screen bg-[var(--p-0a0a0a)] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-[var(--p-c9a84c)] mx-auto"></div>
        <p className="mt-4 text-[var(--p-f5f0e8)] font-sans">Connexion en cours...</p>
      </div>
    </div>
  );
};